// import React, { useState } from "react";
// import axios from "axios";
// import { useNavigate, useParams } from "react-router-dom";
// import { API_BASE_URL } from "../utils/config";
// import { FiMail, FiLock, FiArrowRight, FiCheckCircle, FiAlertCircle } from "react-icons/fi";
// import { FaTasks } from "react-icons/fa";

// const EmailVerification = () => {
//     const [email, setEmail] = useState("");
//     const [otp, setOtp] = useState("");
//     const [otpSent, setOtpSent] = useState(false);
//     const [loading, setLoading] = useState(false);
//     const [message, setMessage] = useState({ text: "", type: "" });
//     const navigate = useNavigate();
//     const { jobId } = useParams();

//     const handleSendOtp = async (e) => {
//         e.preventDefault();
//         if (!email) {
//             setMessage({ text: "Please enter your email address", type: "error" });
//             return;
//         }

//         setLoading(true);
//         setMessage({ text: "", type: "" });

//         try {
//             const res = await axios.post(`${API_BASE_URL}/candidate/send-register-otp`, { email });
//             if (res.data.success) {
//                 setOtpSent(true);
//                 setMessage({ text: "OTP sent successfully to your email!", type: "success" });
//             }
//         } catch (err) {
//             console.error("Send OTP error:", err);
//             setMessage({
//                 text: err.response?.data?.message || "Failed to send OTP. Please try again.",
//                 type: "error"
//             });
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleVerifyOtp = async (e) => {
//         e.preventDefault();
//         if (!otp) {
//             setMessage({ text: "Please enter the verification OTP", type: "error" });
//             return;
//         }

//         setLoading(true);
//         setMessage({ text: "", type: "" });

//         try {
//             const res = await axios.post(`${API_BASE_URL}/candidate/verify-register-otp`, { email, otp });
//             if (res.data.success) {
//                 setMessage({ text: "Email verified successfully! Redirecting to registration...", type: "success" });
//                 setTimeout(() => {
//                     if (jobId) {
//                         navigate(`/candidate-register/${jobId}`, { state: { email } });
//                     } else {
//                         navigate("/candidate-register", { state: { email } });
//                     }
//                 }, 1500);
//             }
//         } catch (err) {
//             console.error("Verify OTP error:", err);
//             setMessage({
//                 text: err.response?.data?.message || "Invalid or expired OTP. Please try again.",
//                 type: "error"
//             });
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6 font-sans">
//             <div className="w-full max-w-5xl bg-white rounded-[2.5rem] shadow-2xl shadow-indigo-100/50 overflow-hidden flex flex-col md:flex-row border border-slate-100 animate-in fade-in zoom-in duration-500">
                
//                 {/* Visual Side */}
//                 <div className="md:w-5/12 bg-gradient-to-br from-indigo-600 via-purple-600 to-blue-600 p-12 text-white flex flex-col justify-between relative overflow-hidden">
//                     <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at -20% -20%,rgba(255,255,255,0.2)_0%,transparent_60%)]"></div>
//                     <div className="absolute bottom-[-10%] right-[-10%] w-64 h-64 bg-white/10 rounded-full blur-3xl"></div>

//                     <div className="relative z-10">
//                         <div className="w-14 h-14 bg-white/20 rounded-2xl flex items-center justify-center mb-10 backdrop-blur-md border border-white/30 shadow-xl">
//                             <FaTasks className="text-2xl" />
//                         </div>
//                         <h2 className="text-4xl font-black leading-tight mb-4">
//                             Verify your <br />
//                             <span className="text-indigo-200">Email Address.</span>
//                         </h2>
//                         <p className="text-lg text-indigo-100/80 font-medium leading-relaxed">
//                             For security purposes, we require a verification step before building your profile.
//                         </p>
//                     </div>

//                     <div className="relative z-10 space-y-6">
//                         <div className="flex items-center gap-4 group">
//                             <div className="w-10 h-10 bg-white/10 rounded-xl flex items-center justify-center border border-white/20 group-hover:bg-white/20 transition-all">
//                                 <FiCheckCircle className="text-indigo-200" />
//                             </div>
//                             <span className="text-xs font-bold text-indigo-100 uppercase tracking-wider">Secured via OTP</span>
//                         </div>
//                         <div className="flex items-center gap-4 group">
//                             <div className="w-10 h-10 bg-white/10 rounded-xl flex items-center justify-center border border-white/20 group-hover:bg-white/20 transition-all">
//                                 <FiCheckCircle className="text-indigo-200" />
//                             </div>
//                             <span className="text-xs font-bold text-indigo-100 uppercase tracking-wider">Spam Protection</span>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Form Side */}
//                 <div className="md:w-7/12 p-12 md:p-16 flex flex-col justify-center bg-white">
//                     <div className="mb-12">
//                         <h1 className="text-2xl font-black text-slate-800 mb-1">Verify Email</h1>
//                         <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">
//                             Step 1 of candidate setup
//                         </p>
//                     </div>

//                     {message.text && (
//                         <div className={`mb-8 p-4 rounded-xl flex items-center gap-3 border ${
//                             message.type === "success"
//                                 ? "bg-emerald-50 text-emerald-600 border-emerald-100"
//                                 : "bg-rose-50 text-rose-600 border-rose-100"
//                             }`}>
//                             {message.type === "success" ? <FiCheckCircle className="text-lg shrink-0" /> : <FiAlertCircle className="text-lg shrink-0" />}
//                             <span className="text-sm font-bold">{message.text}</span>
//                         </div>
//                     )}

//                     {!otpSent ? (
//                         <form onSubmit={handleSendOtp} className="space-y-6">
//                             <div className="space-y-2">
//                                 <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Email Address</label>
//                                 <div className="relative group">
//                                     <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-slate-300 group-focus-within:text-indigo-600 transition-colors">
//                                         <FiMail className="text-lg" />
//                                     </div>
//                                     <input
//                                         type="email"
//                                         value={email}
//                                         onChange={(e) => setEmail(e.target.value)}
//                                         required
//                                         className="w-full pl-11 pr-4 py-3.5 bg-white border border-slate-200 rounded-xl focus:ring-4 focus:ring-indigo-600/5 focus:border-indigo-600 outline-none transition-all text-sm font-medium text-slate-700 placeholder:text-slate-300 shadow-sm shadow-slate-100/50"
//                                         placeholder="you@example.com"
//                                     />
//                                 </div>
//                             </div>

//                             <button
//                                 type="submit"
//                                 disabled={loading}
//                                 className="w-full py-4 px-6 bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white rounded-xl font-bold text-sm tracking-wide shadow-lg shadow-indigo-600/25 hover:shadow-indigo-600/35 transition-all flex items-center justify-center gap-2 disabled:opacity-50"
//                             >
//                                 <span>{loading ? "Sending..." : "Send Verification OTP"}</span>
//                                 {!loading && <FiArrowRight className="text-base" />}
//                             </button>
//                         </form>
//                     ) : (
//                         <form onSubmit={handleVerifyOtp} className="space-y-6 animate-in fade-in slide-in-from-right-4 duration-300">
//                             <div className="space-y-2">
//                                 <div className="flex justify-between items-center">
//                                     <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Verification OTP</label>
//                                     <button 
//                                         type="button" 
//                                         onClick={() => setOtpSent(false)} 
//                                         className="text-[10px] font-bold text-indigo-600 uppercase tracking-widest hover:underline"
//                                     >
//                                         Change Email
//                                     </button>
//                                 </div>
//                                 <div className="relative group">
//                                     <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-slate-300 group-focus-within:text-indigo-600 transition-colors">
//                                         <FiLock className="text-lg" />
//                                     </div>
//                                     <input
//                                         type="text"
//                                         value={otp}
//                                         onChange={(e) => setOtp(e.target.value)}
//                                         required
//                                         maxLength={4}
//                                         className="w-full pl-11 pr-4 py-3.5 bg-white border border-slate-200 rounded-xl focus:ring-4 focus:ring-indigo-600/5 focus:border-indigo-600 outline-none transition-all text-sm font-medium text-slate-700 placeholder:text-slate-300 shadow-sm shadow-slate-100/50 tracking-[0.5em] font-mono text-center"
//                                         placeholder="••••"
//                                     />
//                                 </div>
//                                 <p className="text-xs text-slate-400 font-medium ml-1">
//                                     We sent a 4-digit code to <strong className="text-slate-600">{email}</strong>.
//                                 </p>
//                             </div>

//                             <button
//                                 type="submit"
//                                 disabled={loading}
//                                 className="w-full py-4 px-6 bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white rounded-xl font-bold text-sm tracking-wide shadow-lg shadow-indigo-600/25 hover:shadow-indigo-600/35 transition-all flex items-center justify-center gap-2 disabled:opacity-50"
//                             >
//                                 <span>{loading ? "Verifying..." : "Verify & Continue"}</span>
//                                 {!loading && <FiArrowRight className="text-base" />}
//                             </button>

//                             <div className="text-center mt-4">
//                                 <button 
//                                     type="button"
//                                     onClick={handleSendOtp}
//                                     disabled={loading}
//                                     className="text-xs font-bold text-indigo-600 hover:underline"
//                                 >
//                                     Resend Verification Code
//                                 </button>
//                             </div>
//                         </form>
//                     )}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default EmailVerification;


import React, { useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { API_BASE_URL } from "../utils/config";
import { FiMail, FiLock, FiArrowRight, FiCheckCircle, FiAlertCircle, FiInfo } from "react-icons/fi";
import { FaTasks } from "react-icons/fa";

const EmailVerification = () => {
    const [email, setEmail] = useState("");
    const [otp, setOtp] = useState("");
    const [otpSent, setOtpSent] = useState(false);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({ text: "", type: "" });
    const [showSpamNote, setShowSpamNote] = useState(false);
    const navigate = useNavigate();
    const { jobId } = useParams();

    const handleSendOtp = async (e) => {
        e.preventDefault();
        if (!email) {
            setMessage({ text: "Please enter your email address", type: "error" });
            return;
        }

        setLoading(true);
        setMessage({ text: "", type: "" });
        setShowSpamNote(false);

        try {
            const res = await axios.post(`${API_BASE_URL}/candidate/send-register-otp`, { email });
            if (res.data.success) {
                setOtpSent(true);
                setShowSpamNote(true);
                setMessage({ 
                    text: "OTP sent successfully! Please check your email.", 
                    type: "success" 
                });
            }
        } catch (err) {
            console.error("Send OTP error:", err);
            setMessage({
                text: err.response?.data?.message || "Failed to send OTP. Please try again.",
                type: "error"
            });
        } finally {
            setLoading(false);
        }
    };

    const handleVerifyOtp = async (e) => {
        e.preventDefault();
        if (!otp) {
            setMessage({ text: "Please enter the verification OTP", type: "error" });
            return;
        }

        setLoading(true);
        setMessage({ text: "", type: "" });

        try {
            const res = await axios.post(`${API_BASE_URL}/candidate/verify-register-otp`, { email, otp });
            if (res.data.success) {
                setMessage({ text: "Email verified successfully! Redirecting to registration...", type: "success" });
                setShowSpamNote(false);
                setTimeout(() => {
                    if (jobId) {
                        navigate(`/candidate-register/${jobId}`, { state: { email } });
                    } else {
                        navigate("/candidate-register", { state: { email } });
                    }
                }, 1500);
            }
        } catch (err) {
            console.error("Verify OTP error:", err);
            setMessage({
                text: err.response?.data?.message || "Invalid or expired OTP. Please try again.",
                type: "error"
            });
        } finally {
            setLoading(false);
        }
    };

    const handleResendOtp = async () => {
        setLoading(true);
        setMessage({ text: "", type: "" });
        setShowSpamNote(false);

        try {
            const res = await axios.post(`${API_BASE_URL}/candidate/send-register-otp`, { email });
            if (res.data.success) {
                setShowSpamNote(true);
                setMessage({ 
                    text: "OTP resent successfully! Please check your email.", 
                    type: "success" 
                });
            }
        } catch (err) {
            console.error("Resend OTP error:", err);
            setMessage({
                text: err.response?.data?.message || "Failed to resend OTP. Please try again.",
                type: "error"
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6 font-sans">
            <div className="w-full max-w-5xl bg-white rounded-[2.5rem] shadow-2xl shadow-indigo-100/50 overflow-hidden flex flex-col md:flex-row border border-slate-100 animate-in fade-in zoom-in duration-500">
                
                {/* Visual Side */}
                <div className="md:w-5/12 bg-gradient-to-br from-indigo-600 via-purple-600 to-blue-600 p-12 text-white flex flex-col justify-between relative overflow-hidden">
                    <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_-20%_-20%,rgba(255,255,255,0.2)_0%,transparent_60%)]"></div>
                    <div className="absolute bottom-[-10%] right-[-10%] w-64 h-64 bg-white/10 rounded-full blur-3xl"></div>

                    <div className="relative z-10">
                        <div className="w-14 h-14 bg-white/20 rounded-2xl flex items-center justify-center mb-10 backdrop-blur-md border border-white/30 shadow-xl">
                            <FaTasks className="text-2xl" />
                        </div>
                        <h2 className="text-4xl font-black leading-tight mb-4">
                            Verify your <br />
                            <span className="text-indigo-200">Email Address.</span>
                        </h2>
                        <p className="text-lg text-indigo-100/80 font-medium leading-relaxed">
                            For security purposes, we require a verification step before building your profile.
                        </p>
                    </div>

                    <div className="relative z-10 space-y-6">
                        <div className="flex items-center gap-4 group">
                            <div className="w-10 h-10 bg-white/10 rounded-xl flex items-center justify-center border border-white/20 group-hover:bg-white/20 transition-all">
                                <FiCheckCircle className="text-indigo-200" />
                            </div>
                            <span className="text-xs font-bold text-indigo-100 uppercase tracking-wider">Secured via OTP</span>
                        </div>
                        <div className="flex items-center gap-4 group">
                            <div className="w-10 h-10 bg-white/10 rounded-xl flex items-center justify-center border border-white/20 group-hover:bg-white/20 transition-all">
                                <FiCheckCircle className="text-indigo-200" />
                            </div>
                            <span className="text-xs font-bold text-indigo-100 uppercase tracking-wider">Spam Protection</span>
                        </div>
                    </div>
                </div>

                {/* Form Side */}
                <div className="md:w-7/12 p-12 md:p-16 flex flex-col justify-center bg-white">
                    <div className="mb-12">
                        <h1 className="text-2xl font-black text-slate-800 mb-1">Verify Email</h1>
                        <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">
                            Step 1 of candidate setup
                        </p>
                    </div>

                    {message.text && (
                        <div className={`mb-8 p-4 rounded-xl flex items-start gap-3 border ${
                            message.type === "success"
                                ? "bg-emerald-50 text-emerald-600 border-emerald-100"
                                : "bg-rose-50 text-rose-600 border-rose-100"
                            }`}>
                            {message.type === "success" ? (
                                <FiCheckCircle className="text-lg shrink-0 mt-0.5" />
                            ) : (
                                <FiAlertCircle className="text-lg shrink-0 mt-0.5" />
                            )}
                            <span className="text-sm font-bold">{message.text}</span>
                        </div>
                    )}

                    {/* Spam/Junk Folder Note */}
                    {showSpamNote && (
                        <div className="mb-8 p-4 rounded-xl bg-amber-50 border border-amber-200 flex items-start gap-3 animate-in fade-in slide-in-from-top-2 duration-300">
                            <FiInfo className="text-amber-500 text-lg shrink-0 mt-0.5" />
                            <div className="text-sm text-amber-700">
                                <p className="font-bold">📧 Please check your email inbox.</p>
                                <p className="text-xs mt-1 font-medium text-amber-600">
                                    If you don't see the OTP in your inbox, please check your <strong>Spam</strong>, 
                                    <strong> Junk</strong>, or <strong>Promotions</strong> folder. 
                                    The email might have been filtered incorrectly.
                                </p>
                                <p className="text-xs mt-1 font-medium text-amber-600">
                                    If you still don't receive it, click "Resend Verification Code" below.
                                </p>
                            </div>
                        </div>
                    )}

                    {!otpSent ? (
                        <form onSubmit={handleSendOtp} className="space-y-6">
                            <div className="space-y-2">
                                <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Email Address</label>
                                <div className="relative group">
                                    <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-slate-300 group-focus-within:text-indigo-600 transition-colors">
                                        <FiMail className="text-lg" />
                                    </div>
                                    <input
                                        type="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                        className="w-full pl-11 pr-4 py-3.5 bg-white border border-slate-200 rounded-xl focus:ring-4 focus:ring-indigo-600/5 focus:border-indigo-600 outline-none transition-all text-sm font-medium text-slate-700 placeholder:text-slate-300 shadow-sm shadow-slate-100/50"
                                        placeholder="you@example.com"
                                    />
                                </div>
                                <p className="text-xs text-slate-400 font-medium ml-1">
                                    We'll send a 4-digit verification code to this email.
                                </p>
                            </div>

                            <button
                                type="submit"
                                disabled={loading}
                                className="w-full py-4 px-6 bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white rounded-xl font-bold text-sm tracking-wide shadow-lg shadow-indigo-600/25 hover:shadow-indigo-600/35 transition-all flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                <span>{loading ? "Sending..." : "Send Verification OTP"}</span>
                                {!loading && <FiArrowRight className="text-base" />}
                            </button>
                        </form>
                    ) : (
                        <form onSubmit={handleVerifyOtp} className="space-y-6 animate-in fade-in slide-in-from-right-4 duration-300">
                            <div className="space-y-2">
                                <div className="flex justify-between items-center">
                                    <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Verification OTP</label>
                                    <button 
                                        type="button" 
                                        onClick={() => {
                                            setOtpSent(false);
                                            setShowSpamNote(false);
                                            setMessage({ text: "", type: "" });
                                        }} 
                                        className="text-[10px] font-bold text-indigo-600 uppercase tracking-widest hover:underline"
                                    >
                                        Change Email
                                    </button>
                                </div>
                                <div className="relative group">
                                    <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-slate-300 group-focus-within:text-indigo-600 transition-colors">
                                        <FiLock className="text-lg" />
                                    </div>
                                    <input
                                        type="text"
                                        value={otp}
                                        onChange={(e) => setOtp(e.target.value.replace(/[^0-9]/g, ''))}
                                        required
                                        maxLength={4}
                                        className="w-full pl-11 pr-4 py-3.5 bg-white border border-slate-200 rounded-xl focus:ring-4 focus:ring-indigo-600/5 focus:border-indigo-600 outline-none transition-all text-sm font-medium text-slate-700 placeholder:text-slate-300 shadow-sm shadow-slate-100/50 tracking-[0.5em] font-mono text-center"
                                        placeholder="••••"
                                    />
                                </div>
                                <p className="text-xs text-slate-400 font-medium ml-1">
                                    We sent a 4-digit code to <strong className="text-slate-600">{email}</strong>.
                                </p>
                            </div>

                            <button
                                type="submit"
                                disabled={loading}
                                className="w-full py-4 px-6 bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white rounded-xl font-bold text-sm tracking-wide shadow-lg shadow-indigo-600/25 hover:shadow-indigo-600/35 transition-all flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                <span>{loading ? "Verifying..." : "Verify & Continue"}</span>
                                {!loading && <FiArrowRight className="text-base" />}
                            </button>

                            <div className="text-center mt-4">
                                <button 
                                    type="button"
                                    onClick={handleResendOtp}
                                    disabled={loading}
                                    className="text-xs font-bold text-indigo-600 hover:underline disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    Resend Verification Code
                                </button>
                            </div>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
};

export default EmailVerification;